import { createContext, useContext } from "react";

export interface UIContextType {
  businessId: string;
  bookezToken: string; // Business token from the software
  theme: "dark" | "light" | "";
  plaidClientUserId?: string; // Optional user ID for client-specific operations
  plaidClientUserName?: string; // Optional user token for client-specific operations
  onError?: (error: Error) => void;
  onSuccess?: (
    apiType: "GET" | "POST" | "DOWNLOAD" | "OPTIONS",
    apiName: string,
    message: string
  ) => void;
}

const UIContext = createContext<UIContextType>({
  businessId: "",
  bookezToken: "",
  plaidClientUserId: "",
  plaidClientUserName: "",
  onError: undefined,
  onSuccess: undefined,
  theme: "",
});

const useProviderContext = (): UIContextType => {
  const context = useContext(UIContext);

  if (context === undefined) {
    throw new Error("Component must be used within a UIProvider");
  }

  return context;
};

export { useProviderContext, UIContext };
